
import { defineComponent, ref } from 'vue';
import { useCrudBase } from '@/core/composables/CrudBase';
import TelaPadraoCrud from '@/core/components/TelaPadraoCrud.vue';
import ServicoPerfilUsuario from '@/servicos/MeuSistema/ServicoPerfilUsuario';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import { IOrdenacao } from '@/core/models/Consulta/IOrdenacao';
import PerfilUsuarioModal from '@/views/MeuSistema/Usuarios/PerfilUsuarioModal.vue';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';

export default defineComponent({
  name: 'PerfilUsuario',
  components: {
    TelaPadraoCrud,
    PerfilUsuarioModal,
  },
  setup() {
    const {
      crudBase, preencherEstrutura, exibirModal, sincronizaTelaCrud,
    } = useCrudBase();
    const servicoPerfilUsuario = new ServicoPerfilUsuario();
    const refCrud = ref<InstanceType<typeof TelaPadraoCrud>>();

    crudBase.estrutura = preencherEstrutura();
    crudBase.estrutura.apresentarEmpresas = false;
    crudBase.estrutura.verificarCadastroCompartilhado = false;
    crudBase.estrutura.botaoPrincipalAcao = 'Novo perfil';
    crudBase.estrutura.mensagemExclusao = 'Você confirma a exclusão do perfil';
    crudBase.estrutura.colunasGrade = [
      {
        title: 'Código', dataIndex: 'codigo', key: 'CodigoPerfilUsuario', position: 0, visible: false, width: 100,
      },
      {
        title: 'Descrição', dataIndex: 'descricao', key: 'DescricaoPerfilUsuario', position: 1, visible: true, ordering: true, fixed: 'left', align: 'left', customRenderRow: ECustomRenderRow.LinkAcao,
      },
      {
        title: 'Status', dataIndex: 'ativo', key: 'ativo', position: 2, visible: true, align: 'center', customRenderRow: ECustomRenderRow.TagAtivo,
      },
      {
        title: 'Ações', key: 'acoes', position: 3, visible: true, fixed: 'right', width: 100, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
      },
    ];
    crudBase.estrutura.ordenacaoPadraoGrade.push({ identificador: 'CodigoPerfilUsuario', ordem: 'DESC' } as IOrdenacao);

    async function sincronizarRegistro(acao: EPermissaoDados, codigoRegistro: number) {
      if (refCrud.value !== undefined) {
        await refCrud.value.sincronizarRegistro(acao, codigoRegistro);
      }
    }

    return {
      crudBase,
      servicoPerfilUsuario,
      refCrud,
      exibirModal,
      sincronizaTelaCrud,
      sincronizarRegistro,
    };
  },
});
